import axios from "axios";
import { API } from "../backend";

const register = (
  name,
  email,
  password,
  company_name,
  address,
  country,
  state,
  city,
  zip_code,
  phone_number,
  plan,
  userallow,
) => {
  return axios.post(API + "sign-up/", {
    name,
    company_name,
    address,
    country,
    state,
    city,
    zip_code,
    phone_number,
    plan,
    userallow,
    user: {
      email: email,
      username: email,
      password: password,
    },
  });
};
const login = (username, password) => {
  return axios
    .post(API + "login/", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.access) {
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem(
          "username",
          JSON.stringify(response.data.username),
        );
        localStorage.setItem("locale", response.data.locale);
        localStorage.setItem("currency", response.data.currency);
        localStorage.setItem("companyid", response.data.companyid);
        localStorage.setItem("parent", response.data.parent);
        localStorage.setItem("permissions", response.data.permissions);
        localStorage.setItem("customer", response.data.customer);
        localStorage.setItem("userid", response.data.user_id);
        localStorage.setItem("last_login", response.data.lastlogin);

        localStorage.setItem(
          "active_company_id",
          response.data.active_company_id || response.data.companyid,
        );
        localStorage.setItem(
          "active_company_name",
          response.data.active_company_name || "",
        );
        localStorage.setItem(
          "managed_clients_count",
          response.data.managed_clients_count || 0,
        );
        localStorage.setItem(
          "accessible_companies",
          JSON.stringify(response.data.accessible_companies || []),
        );
      }

      return response.data;
    })
    .catch((error) => {
      // If backend sends JSON error response
      //   if (error.response && error.response.data) {
      //     return { error: error.response.data.detail || error.response.data.error || "Login failed" };
      //   }
      //   // Fallback
      //   return { error: "Something went wrong. Please try again." };
      // });
      let errorMessage = "Something went wrong. Please try again.";

      if (error.response && error.response.data) {
        // detail object
        if (
          error.response.data.detail &&
          typeof error.response.data.detail === "object"
        ) {
          errorMessage = error.response.data.detail.error || errorMessage;
        }

        // detail string
        else if (typeof error.response.data.detail === "string") {
          errorMessage = error.response.data.detail;
        }

        // error field
        else if (error.response.data.error) {
          // array
          if (Array.isArray(error.response.data.error)) {
            errorMessage = error.response.data.error[0];
          }

          // string
          else {
            errorMessage = error.response.data.error;
          }
        }
      }

      return { error: errorMessage };
    });
};

// const logout = () => {
//   window.localStorage.clear();
//   // Return a resolved Promise to indicate successful logout
//   return Promise.resolve();
// };

const logout = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    localStorage.clear();
    return Promise.resolve();
  }

  return axios
    .post(
      API + "logout/",
      {
        refresh: user.refresh, // send refresh token
      },
      {
        headers: {
          Authorization: `Bearer ${user.access}`, // send access token
          "Content-Type": "application/json",
        },
      },
    )
    .then((response) => {
      localStorage.clear();
      return response.data;
    })
    .catch((error) => {
      // Even if backend fails, force logout on frontend
      localStorage.clear();
      return Promise.reject(error);
    });
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const forgotpassword = (username) => {
  return axios.post(API + "helper/send-forgotpassword-email/", {
    username,
  });
};
const resetpassword = (username) => {
  return axios.post(API + "helper/send-resetpassword-email/", {
    username,
  });
};

const AuthService = {
  register,
  login,
  logout,
  getCurrentUser,
  forgotpassword,
  resetpassword,
};
export default AuthService;
